import { Howl } from 'howler';

// Create sound objects - use process.env.PUBLIC_URL to ensure correct path
const sounds = {
  whistle: new Howl({
    src: [`${process.env.PUBLIC_URL}/sounds/whistle.mp3`],
    volume: 0.8
  }),
  warning: new Howl({
    src: [`${process.env.PUBLIC_URL}/sounds/warning.mp3`],
    volume: 0.7
  }),
  goal: new Howl({
    src: [`${process.env.PUBLIC_URL}/sounds/goal.mp3`],
    volume: 0.7
  }),
  click: new Howl({
    src: [`${process.env.PUBLIC_URL}/sounds/click.mp3`],
    volume: 0.5
  })
};

/**
 * Play a sound
 * @param {string} soundName - Name of the sound to play
 * @param {boolean} soundEnabled - Whether sound is enabled
 */
export const playSound = (soundName, soundEnabled = true) => {
  if (!soundEnabled) return;
  
  const sound = sounds[soundName];
  if (sound) {
    sound.play();
  }
};
